export const HEADER = {
  LOGIN: 'Login',
  LOGOUT: 'Logout',
  ACCOUNT: {
    INFO: 'Account Information',
    LOGOUT: 'Logout',
  },
  AIDE: 'AIDE',
  SEER: 'SEER',
};

export const SITE = {
  TITLE: 'Admin Portal',
  ERROR: 'Error',
};
export const PAGE_TITLE = {
  PORTAL: 'Portal',
  LOGIN: 'Login',
  ERROR: 'Error',
  ACC_INFO: 'Account Information',
  RESET_PWD: 'Reset Password',
  FORGET_PWD: 'Forget Password',
  ORG: 'Organisations',
  ORG_INFO: 'Organisation Information',
  ROLES_SETTINGS: 'Roles Settings',
  USERS_MANAGEMENT: 'Users Management',
  INTERNAL_HOME: 'Internal Homepage',
  INTERNAL_USERS_MANAGEMENT: 'Internal Users Management',
  INTERNAL_USERS: 'Internal Users',
  PUBLIC_USERS_MANAGEMENT: 'Public Users Management',
  PUBLIC_USERS: 'Public Users',
  CAMPAIGN_MANAGEMENT: 'Campaign Management',
  CAMPAIGNS: 'Campaigns',
  CAMPAIGN_SIGNEES: 'Campaign Signees',
  SUBSCRIPTION_PLANS: 'Subscription Plans',
  SUBSCRIPTIONS_MANAGEMENT: 'Subscription Management',
  SUBSCRIPTIONS: 'Subscriptions',
  ORG_MANAGEMENT: 'Organisation Management',
  CHANGE_PWD: 'Change Password',
  SCOUT_TRAINING: 'Scout Training',
  SCOUT_AIS: 'Scout AIs',
  SEER_DEMO: 'SEER Demo',
  AIDE: 'AIDE',
  AIDE_SCOUT_MANAGER: 'AIDE Scout Manager',
  AIDE_NERD_TRAINING: 'NERD Training',
  COMPANY_DETAIL: 'Company page',
  KEY_DEV_MANAGER: 'KeyDev Manager',
  KEY_DEV_REQUEST_LOG: 'KeyDev Request Log',
  KEY_DEV_QUALITY_MONITORING: 'KeyDev Quality Monitoring',
  KEY_DEV_CLUSTER_MANAGEMENT: 'KeyDev Cluster Management',
  KEY_DEV_DETAIL: 'KeyDev Detail',
  KEY_DEV_DETAIL_UPDATE_HISTORY: 'KeyDev Detail Update History',
};

export const SIDE_BAR = {
  INFO: 'Information',
  ROLES_SETTINGS: 'Roles Settings',
  USERS_MANAGEMENT: 'Users Management',
  SUBSCRIPTIONS: 'Subscriptions',
  INTERNAL_USERS_MANAGEMENT: 'Internal Users Management',
  INTERNAL_USERS: 'Internal Users',
  PUBLIC_USERS_MANAGEMENT: 'Public Users Management',
  PUBLIC_USERS: 'Public Users',
  CAMPAIGNS: 'Campaigns',
  CAMPAIGN_SIGNEES: 'Campaign Signees',
  SUBSCRIPTION_PLANS: 'Subscription Plans',
  ORGANISATIONS: 'Organisations',
  DETAIL: 'Detail',
  CHANGE_PWD: 'Change Password',
};

export const TAB_NAME = {
  INFO: 'Information',
  TARGET_LIST: 'Target List',
  SAVED_SEARCH: 'Saved Search',
  SUBSCRIPTION_PLAN: 'Subscription Plan',
  SUBSCRIPTION: 'Subscription',
  USERS: 'Users',
};

export const FORM_LABEL = {
  AUTO_APPROVE: 'Auto Approve',
  CONTENT: 'Contents',
  COUNTRY: 'Country',
  LICENSE: 'Licenses',
  MAX_USERS: 'Max Users',
  CAMPAIGN: 'Campaigns',
  CAMPAIGN_TYPE: 'Campaign Type',
  DAILY_DIGEST_TEMPLATE: 'Daily Digest Template',
  CHOOSE_ORG: 'Choose Organisation:',
  NAME: 'Name',
  ALLOW_EXTERNAL: 'Allow External',
  IDP_ENTITY_ID: 'Idp Entity Id',
  SSO_URL: 'Single Sign on Service URL',
  SLO_URL: 'Single Logout Service URL',
  ALIAS: 'Alias',
  DISPLAY_NAME: 'Display Name',
  SIGNING_CERTIFCATE: 'Signing Certificate',
  ENCRYPTION_PUBLIC_KEY: 'Encryption Public Key',
  METADATA_DESCRIPTOR_URL: 'Metadata Descriptor URL',
  WANT_AUTHN_REQUESTS_SIGNED: 'Want Authn Requests Signed',
  FIRST_NAME: 'First Name',
  LAST_NAME: 'Last Name',
  USERNAME: 'Username',
  PASSWORD: 'Password',
  EMAIL: 'Email',
  LOCATION: 'Location',
  PHONE: 'Phone',
  CONTACT_NO: 'Contact Number',
  CREATED_BY: 'Created By',
  CREATED_ON: 'Created On',
  DATE_FROM: 'Date From',
  CONTACT_PERSON: 'Contact Person',
  COMPANY: 'Company',
  DESC: 'Description',
  PRICE: 'Price',
  LICENSE_COUNT: 'Number of Licenses',
  START_DATE: 'Start Date',
  END_DATE: 'End Date',
  FEATURES: 'Features',
  PERMISSIONS: 'Permissions',
  ROLES: 'Roles Assigned',
  REGION: 'Region',
  PERIOD: 'Period',
  CAMPAIGN_PERIOD: 'Campaign Period',
  CONTACT_URL: 'Contact URL',
  BANNER_URL: 'Banner URL',
  REMARK: 'Remark',
  SCOUT_AI: 'Scout AI',
  AI_MODEL: 'AI Model',
  SEARCH_STRING: 'Search String',
  TYPE: 'Type',
  SEARCH_TYPE: 'Search Type',
  SUB_TYPE: 'Subscription Type',
  STATUS: 'Status',
  SEARCH: 'Search',
  DURATION: 'Duration',
  OLD_PWD: 'Old Password',
  NEW_PWD: 'New Password',
  CONFIRM_PWD: 'Confirm Password',
  TARGET: 'Target',
  WEBSITE: 'Website',
  SALE_SOURCE: 'Sale Source',
  SALE_REGION: 'Sale region',
  INDUSTRY: 'Industry',
  SUBSCRIPTION_PLAN: 'Subscription Plan',
  INFO: 'Information',
  USERS: 'Users',
  ORG: 'Organisation',
  TITLE_OPTIONAL: 'Title (Optional)',
  TEXT_BODY: 'Text Body',
  USER_TYPE: 'User Type',
  INTERNAL: 'Internal',
  PUBLIC: 'Public',
};

export const USER_TYPE = {
  true: 'Public',
  false: 'Internal',
};

export const TABLE_HEADER = {
  NAME: 'Name',
  DESC: 'Description',
  STATUS: 'Status',
  DURATION: 'Duration',
  ACTIVE: 'Active',
  INACTIVE: 'Inactive',
};

export const FORM_INPUT = {
  ARTICLE: 'Article',
  PERSONAL: 'Personal',
  PEOPLE: 'People',
  SCOUT_AI: 'ScoutAI',
  ORG: 'Organisation',
  NONE: 'None',
};

export const SWITCH_LABEL = {
  DISABLED: 'Disabled',
  ENABLE_ALL: 'Enable All',
  ENABLED: 'Enabled',
};

export const DURATION_INPUT = {
  DAY: 'Day(s)',
  WEEK: 'Week(s)',
  MONTH: 'Month(s)',
  YEAR: 'Year(s)',
};

export const UNLIMITED_DURATION = {
  value: 'UNLIMITED',
  text: 'Unlimited',
};

export const REGION_INPUT = {
  SG: 'Singapore (SEA)',
  MY: 'Malaysia',
  ANZ: 'Australia and New Zealand',
  JP: 'Japan',
  HK: 'Rest of world (HK)',
};

export const ORG_STATUS = {
  PROSPECT: 'Prospect',
  TRIAL: 'Trial',
  EX_TRIAL: 'Ex-Trial',
  LIVE: 'Live',
  CLOSED: 'Closed',
};

export const ORG_SALE_REGION = {
  'Asia Hong Kong': 'Asia Hong Kong',
  'Asia Singapore': 'Asia Singapore',
  Japan: 'Japan',
  EMEA: 'EMEA',
  Americas: 'Americas',
  Australia: 'Australia',
};

export const ORG_SALE_SOURCE = {
  Event: 'Event',
  'External Referral': 'External Referral',
  Inbound: 'Inbound',
  'Internal Referral': 'Internal Referral',
  Marketing: 'Marketing',
  Prospecting: 'Prospecting',
  Other: 'Other',
};

export const ORG_INDUSTRY = {
  Academic: 'Academic',
  'Associations / Research Institutions':
    'Associations / Research Institutions',
  Accounting: 'Accounting',
  'Asset Management': 'Asset Management',
  'Commercial Banking': 'Commercial Banking',
  'Government / Regulatory': 'Government / Regulatory',
  'Hedge Fund': 'Hedge Fund',
  Insurance: 'Insurance',
  'Law Firm': 'Law Firm',
  'PE / VC': 'PE / VC',
  'PR / Marketing / Media': 'PR / Marketing / Media',
  'IB - M&A': 'IB - M&A',
  'IB - Corporate Finance': 'IB - Corporate Finance',
  'IB - Research': 'IB - Research',
  'Consultancy / Advisory': 'Consultancy / Advisory',
  'Risk & Compliance': 'Risk & Compliance',
  'Bus Dev / Sales': 'Bus Dev / Sales',
  'Real Estate': 'Real Estate',
  Corporate: 'Corporate',
  Others: 'Others',
};

export const CAMPAIGN_EVENT_CAMPAIGN_TYPE = {
  DIGEST: {
    text: 'Campaign Digest with Trial Account',
    value: 0,
  },
  DIGEST_ONLY: {
    text: 'Campaign Digest',
    value: 1,
  },
  TRIAL_ONLY: {
    text: 'Trial Account',
    value: 2,
  },
};

export const DAILY_DIGEST_TEMPLATE = {
  CAMPAIGN_TRENDING_TOPIC_DIGEST: {
    text: 'Trending News',
    value: 'CAMPAIGN_TRENDING_TOPIC_DIGEST',
  },
  CAMPAIGN_SCOUTAI_DIGEST: {
    text: 'Scout AI',
    value: 'CAMPAIGN_SCOUTAI_DIGEST',
  },
};

export const AUTO_APPROVE = {
  NA: {
    text: 'No',
    value: 0,
  },
  BULK: {
    text: 'Only for Bulk Create',
    value: 1,
  },
  ALL: {
    text: 'All',
    value: 2,
  },
};

export const SUB_TYPE_INPUT = {
  PERSONAL: 'Personal',
  ORGANISATION: 'Organisation',
  API: 'API',
};

export const DEFAULT_REGION = 'SG';

export const FORM_BUTTON_TEXT = {
  BACK: 'Back',
  CONTINUE: 'Continue',
  EDIT: 'Edit',
  CREATE: 'Create',
  SAVE: 'Save',
  DELETE: 'Delete',
  INVITE: 'Invite',
  YES: 'Yes',
  NO: 'No',
  SUBMIT: 'Submit',
  CLOSE: 'Close',
  CANCEL: 'Cancel',
  GO_TO_LOGIN: 'Go to Login',
  ADD: 'Add',
  LOGIN: 'Login',
  FORGET_PWD: 'Forget Password?',
  APPROVE: 'Approve',
  REJECT: 'Reject',
  REMOVE: 'Remove',
  SEARCH: 'Search',
  SEND: 'Send',
  ADD_ALL: 'Add All',
  REMOVE_ALL: 'Remove All',
  CLEAR: 'Clear',
  EXPORT: 'Export',
  RESET: 'RESET',
  SEARCH_UPPER_CASE: 'SEARCH',
};

export const CAMPAIGN_USER_STATUS = {
  PENDING: {
    text: 'Pending',
    status: 0,
  },
  SUBMITTED: {
    text: 'Requested',
    status: 1,
  },
  APPROVED: {
    text: 'Approved',
    status: 2,
  },
  REJECTED: {
    text: 'Rejected',
    status: 3,
  },
};

export const CAMPAIGN_EVENT_USER_STATUS = {
  SUBMITTED: {
    text: 'Requested',
    color: 'primary',
    status: 0,
    hidden: false,
  },
  APPROVED: {
    text: 'Approved',
    color: 'success',
    status: 1,
    hidden: false,
  },
  EXTENDED: {
    text: 'Extended',
    color: 'info',
    status: 2,
    hidden: true,
  },
  REJECTED: {
    text: 'Rejected',
    color: 'danger',
    status: 3,
    hidden: false,
  },
  UNSUBSCRIBED: {
    text: 'Unsubscribed',
    color: 'secondary',
    status: 4,
    hidden: false,
  },
};

export const FORM_FEEDBACK = {
  INVALID_CAMPAIGN: 'Must have at least one Campaign',
  INVALID_NAME: 'Invalid Name',
  INVALID_FIRST_NAME: 'Invalid First Name',
  INVALID_LAST_NAME: 'Invalid Last Name',
  INVALID_USERNAME: 'Invalid Username',
  INVALID_EMAIL: 'Invalid Email',
  INVALID_LOCATION: 'Invalid Location',
  INVALID_PHONE: 'Invalid Phone',
  INVALID_CONTACT_NO: 'Invalid Contact Number',
  INVALID_COMPANY: 'Invalid Company',
  INVALID_DESC: 'Invalid Description',
  INVALID_START_DATE: 'Invalid Start date',
  INVALID_END_DATE: 'Invalid End date',
  INVALID_PRICE: 'Invalid Price',
  INVALID_LICENSE_COUNT: 'Number of license need to be more than 1.',
  INVALID_USER_COUNT: 'Number of users need to be more than 1.',
  INVALID_FEATURES: 'Features cannot be empty',
  INVALID_PERMISSIONS: 'Permissions cannot be empty',
  INVALID_DURATION: 'Invalid Duration',
  INVALID_DURATION_VALUE: 'Invalid Duration Value',
  INVALID_DURATION_TYPE: 'Invalid Duration Type',
  INVALID_REGION: 'Invalid Region',
  INVALID_PERIOD: 'Invalid Period',
  INVALID_CONTACT_URL: 'Invalid Contact URL',
  INVALID_BANNER_URL: 'Invalid Banner URL',
  INVALID_SEARCH_TYPE: 'Invalid Search Type',
  INVALID_SEARCH_STRING: 'Invalid Search String',
  INVALID_SCOUT_AI: 'Must have at least one scoutAI',
  INVALID_STATUS: 'Status cannot be empty',
  INVALID_NEW_PWD: 'New password cannot be the same with old password',
  INVALID_CONFIRM_PWD: 'Confirm password does not match with new password',
  INVALID_ORG: 'Invalid Organisation',
  LOGIN_FAILED: 'Username or password is incorrect',
  NO_ACTIVE_ROLE: 'No active role',
  INVALID_SUB_PLAN: 'Please choose a subscription plan',
  INVALID_CREDIT: 'Credit cannot be empty',
  INVALID_SSOURL: 'Invalid SSO URL',
  INVALID_SLOURL: 'Invalid SLO URL',
  INVALID_IDP_ENTITY_ID: 'Invalid Idp Entity ID',
  INVALID_ALIAS: 'Alias cannot be empty',
  INVALID_DISPLAY_NAME: 'Idp display name cannot be empty',
  INVALID_METADATA_DESCRIPTOR_URL: 'Metadata descriptor cannot be empty',
  INVALID_SIGNING_CERTIFICATE: 'Invalid Signing Certificate',
  INVALID_ENCRYPTION_PUBLIC_KEY: 'Invalid Encryption Public Key',
  INVALID_EMPTY_DATE: 'Date is required',
  INVALID_DATE: 'Enter a valid date',
  INVALID_DATE_FUTURE: 'Date cannot be in the future',
};

export const FORM_TEXT = {
  MULTIPLE_EMAIL:
    'Tips: Add ";" between email address to invite multiple user.',
};

export const PASSWORD_CHECK = {
  REQUIREMENTS: 'Requirements:',
  LENGTH: 'Contains 8 to 20 characters',
  UPPER_CASE: 'At least 1 uppercase letter',
  LOWER_CASE: 'At least 1 lowercase letter',
  NUMBER: 'At least 1 number',
  SPECIAL_CHARACTER: 'At least 1 special character',
};

export const PLACEHOLDER = {
  SEARCH_ARTICLE: 'Search Articles',
  SEARCH: 'Search',
  USER_EMAIL: 'User email address',
};

export const HEADING = {
  SCOUTS: 'Scouts',
  FILTERS: 'Filters',
};

export const SUB_TITLE = {
  PWD_CHANGED: 'Password Changed',
  ADD_CAMPAIGN: 'Add Campaign',
  ADD_CAMPAIGN_USER: 'Add Campaign User',
  CAMPAIGNS: 'Campaigns',
  CAMPAIGN_SIGNEES: 'Campaign Signees',
  CAMPAIGN_INFO: 'Campaign Information',
  ROLE_OVERVIEW: 'Role Overview',
  ADD_ROLE: 'Add Role',
  EDIT_ROLE: 'Edit Role',
  ADD_ORG: 'Add Organisation',
  EDIT_ORG: 'Edit Organisation',
  USER_PROFILE: 'User Profile',
  ADD_USER: 'Add User',
  EDIT_USER: 'Edit User',
  INVITE_USER: 'Invite User',
  SUB_PLAN_OVERVIEW: 'Subscription Plan Overview',
  ADD_SUB_PLAN: 'Add Subscription Plan',
  EDIT_SUB_PLAN: 'Edit Subscription Plan',
  CONFIRMATION: 'Confirmation',
  ORG_OVERVIEW: 'Organisation Overview',
  ORGANISATIONS: 'Organisations',
  SCOUT_OVERVIEW: 'Scout Overview',
  SCOUT_MANAGER: 'Scout Manager',
  CREATE_SCOUT: 'Create Scout',
  SEARCH_RESULTS: 'Search Results',
  EDIT_SCOUT: 'Edit Scout',
  EXIT: 'Exit',
};

export const SIDE_BAR_GROUP_NAME = {
  SUBSCRIPTIONS: 'Subscriptions',
  CAMPAIGN_MANAGEMENT: 'Campaign Management',
  USER_MANAGEMENT: 'User Management',
  ORG_MANAGEMENT: 'Organisation Management',
};
